// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"SearchTypeSelection_formContainer__2n_Ku"};